import { Reveal } from "./Reveal";
import { CHAPTERS } from "../../data";

export const About = () => (
  <section id="about" className="py-24 sm:py-36 bg-[#F8F6F0]">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.28em] text-[#7A766C] mb-8">— The Studio</p>
      </Reveal>

      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-6">
          <Reveal>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#1A1A18]">
              Beauty as a <span className="italic text-[#3E3B32]">private ritual</span> — not a production line.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-[#4A4843] leading-relaxed max-w-md">
              Sové is a considered little studio built around one thing: your skin, given time.
              No rushing, no upselling — just honest, tailored care.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:pt-4">
          <div className="space-y-12">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.06}>
                <div className="grid grid-cols-12 gap-4 sm:gap-6 border-t border-[#D5CFC1] pt-8">
                  <span className="font-bodoni col-span-2 text-2xl sm:text-3xl text-[#B7B0A0]">{c.n}</span>
                  <div className="col-span-10">
                    <h3 className="font-serif text-2xl sm:text-3xl text-[#1A1A18] mb-3">{c.title}</h3>
                    <p className="text-[#4A4843] leading-relaxed max-w-lg">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
